import 'components/newIdentifyMethods/video/VideoSelfieBiometricsChoice/VideoselfieWithoutBiometricsLink/VideoSelfieWithoutBiometricsLink.scss';
import FormattedTextWithComponents from 'components/FormattedTextWithComponents/FormattedTextWithComponents';
import { formatText } from 'core/i18n';
import React from 'react';

const VideoselfieWithoutBiometricsLink = ({ onClick }) => {
    return (
        <div className="videoselfie-without-biometrics-link">
            <FormattedTextWithComponents
                value="videoselfie-withoutBiometricsLinkMessage"
                injectedComponents={[
                    <span
                        key="videoselfie-withoutBiometricsLinkMessageLink"
                        role="button"
                        className="videoselfie-without-biometrics-link__link"
                        onClick={onClick}
                        tabIndex="0"
                        onKeyDown={onClick}
                    >
                        {formatText('videoselfie-withoutBiometricsLinkMessageLink')}
                    </span>,
                ]}
            />
        </div>
    );
};

export default VideoselfieWithoutBiometricsLink;
